module.exports = __webpack_public_path__ + "static/media/Michele_Lullaby.8867049e.jpg";